export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Regular.woff2?cd5e231e0cc53b2cb2c029b09b917782";